<ng-container *ngIf="(profile$ | async) as profile">
  <prlw-demo-access-ui
    (eventGoToProfilePage)="handleEventGoToProfilePage()"
    (eventLogout)="handleEventLogout()"
    [profile]="profile"
  ></prlw-demo-access-ui>
</ng-container>
